import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';
import { BoothTier } from './types';

export const boothTiersAdapter = createEntityAdapter<BoothTier>({});

export const selectBoothTiersState = (state: any) => state.cms?.boothTiers || {};

export const selectBoothTiersFetchingState = (state: any) => !!state.cms?.boothTiers?.fetching;

export const {
  selectIds: selectBoothTierIds,
  selectEntities: selectBoothTierEntities,
  selectAll: selectAllBoothTiers,
  selectById: selectBoothTierById,
  selectTotal: selectTotalBoothTiers,
} = boothTiersAdapter.getSelectors(selectBoothTiersState);

export const selectTierNameById = createSelector(
  selectBoothTierById,
  (tier) => (tier?.nameVisible ? tier?.name : null),
);
